package com.eladfinish.bible.contest.screens.completeVerse.usecases

class GetIndexOfNextMissingWordUseCase {
    /*
    WordsIndicesData(
        list = listOf(1, -2, 3, 4, 5, 6, 7, 8, 9, 10, -11, 12, -13, 14, 15),
        current = 10,                               ...]^ [...
        actual = 12,
    )
    ==> [12, -13, 14, 15, 1, -2, 3, 4, 5, 6, 7, 8, 9, 10, -11]
     */
    operator fun invoke(allWordsIndices: List<Int>, currentWordIndex: Int): Int =
        (allWordsIndices.takeLast(allWordsIndices.size - currentWordIndex - 1) + allWordsIndices.take(currentWordIndex + 1))
            .indexOfFirst {
                it < 0 // not yet completed (still blank)
            }
            .plus(currentWordIndex + 1)
            .mod(allWordsIndices.size)

}
